let FILTERS = {
    capitalize: function (str) {
        str = str.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
            str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
    },
    uppercase: function (value) {
        return value.toUpperCase()
    },
    lowercase: function (value) {
        return value.toLowerCase()
    },
    replaceunderscore: function (value) {
        return value.replace(/_/g, " ");
    },
    parsecontent: function (value) {
        var result = '';
        if (value && value.length > 0) {
            result = value.replace(/&amp;/g, '&');
            result = result.replace('&lt;sup&gt;', '<sup>');
            result = result.replace('&lt;/sup&gt;', '</sup>');
        }
        return result;
    },
}

export default {
    install(Vue, options) {
        Object.keys(FILTERS).forEach(key => {
            Vue.filter(key, FILTERS[key]);
        })
    }
}